import { supabase } from './supabase';

interface SendTestEmailParams {
  userId: string;
  toEmail: string;
  toName: string;
  subject: string;
  content: string;
  fromName?: string;
}

export async function sendTestEmail({
  userId,
  toEmail,
  toName,
  subject,
  content,
  fromName,
}: SendTestEmailParams): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();

  if (!session) {
    throw new Error('Geen actieve sessie gevonden');
  }

  const { data: userData } = await supabase
    .from('users')
    .select('first_name')
    .eq('id', userId)
    .single();

  const parseFirstName = (text: string, firstName: string | null) => {
    return text.replace(/\{\{first_name(\|([^}]+))?\}\}/g, (match, pipe, fallback) => {
      return firstName || fallback || 'lezer';
    });
  };

  const recipientFirstName = toName.split(' ')[0] || toName || 'lezer';
  const testContent = parseFirstName(content, recipientFirstName);
  const testSubject = parseFirstName(subject, recipientFirstName);

  const response = await fetch(
    `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-test-email`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${session.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        toEmail,
        toName: recipientFirstName,
        subject: testSubject,
        content: testContent,
        fromName: fromName || userData?.first_name,
      }),
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    console.error('Test email error:', { status: response.status, statusText: response.statusText, errorData });
    throw new Error(errorData.error || 'Failed to send test email');
  }
}
